import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { Session } from 'common/models';
import { Nullable } from 'common/types';

import StatusText, { Statuses } from './StatusText';

export type SessionStatusesProps = Pick<Session, 'status' | 'monitorStatus'>;

export const useSessionStatuses = ({
  status,
  monitorStatus,
}: SessionStatusesProps): Nullable<{
  botStatus: Statuses;
  rthStatus: Statuses;
  ahStatus: Statuses;
  phStatus: Statuses;
}> => {
  const isRthActive = monitorStatus === 'rthMarket';
  const isAhActive = monitorStatus === 'ahMarket';
  const isPhActive = monitorStatus === 'phMarket';

  return {
    botStatus: status,
    rthStatus: monitorStatus ? (isRthActive ? 'active' : 'paused') : null,
    ahStatus: monitorStatus ? (isAhActive ? 'active' : 'paused') : null,
    phStatus: monitorStatus ? (isPhActive ? 'active' : 'paused') : null,
  };
};

const SessionStatuses: FC<SessionStatusesProps> = (props) => {
  const { t } = useTranslation();
  const { rthStatus, ahStatus, phStatus, botStatus } =
    useSessionStatuses(props);

  return (
    <Fragment>
      <StatusText
        status={botStatus}
        prefix={t('components.sessionStatuses.bot')}
      />
      <StatusText
        status={phStatus}
        prefix={t('components.sessionStatuses.prehours')}
      />
      <StatusText
        status={rthStatus}
        prefix={t('components.sessionStatuses.rth')}
      />
      <StatusText
        status={ahStatus}
        prefix={t('components.sessionStatuses.afterhours')}
      />
    </Fragment>
  );
};

export default SessionStatuses;
